import { SolIcon } from '@sol/icons';
import { SolButtonType } from '../models/core/sol-button';
import type { SolBannerAction, SolBannerMood } from '../models/core/sol-banner';

export class SolBannerTools {
  public static icon(mood: SolBannerMood): SolIcon {
    switch (mood) {
      case 'danger':
        return SolIcon.error;
      case 'success':
        return SolIcon.check;
      case 'warning':
        return SolIcon.warning;
      case 'info':
        return SolIcon.info;
    }
  }

  public static role(mood: SolBannerMood): string {
    return mood === 'danger' || mood === 'warning' ? 'alert' : 'status';
  }

  public static actionType(primary: boolean): SolButtonType {
    return primary ? SolButtonType.secondary : SolButtonType.transparent;
  }

  public static hostClass(mood: SolBannerMood): string {
    return `sol-banner sol-banner-${mood}`;
  }

  public static visibleAction(action: SolBannerAction | undefined): SolBannerAction | undefined {
    return action !== undefined && !action.text.isEmpty() ? action : undefined;
  }
}
